import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {TaskTagButtonsLayout,FilterCheckBox,AddNewButtonLayout, PageSaveButton, TableIcon} from '../../common/Global/globalStyles.style';
import SelectedDocumentDialog from './selectedDocument';
import {getLocalStorageVariables,getThemeSettingsVariables,removeHtmlTags,ifEmptyReturn,getStringWithSpaceAfterComma,
    isEmptyVariable, isEmptyArray, isJsonString,hasFeatureAccess,
    handleTokenExpiry} from '../../common/Global/commonFunctions';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import * as TemplateConstants from '../../common/Global/templateConstants';
import moment from "moment";
import AlertDialog from '../../common/AlertDialog';
import FrameworkClauseInfoDialog from './Common/frameworkClauseInfoDialog';

let themeSettings = getThemeSettingsVariables();
let userDetails = getLocalStorageVariables();

//if the status is draft or created then there will be auto save other wise no...
const emptyString = "-";
const notRequiredString = "Not Required";

class TaskDetails extends Component{
    
    constructor(props) {
        super(props);

        this.state = {
            menus:{
                Tasks:"ALL",
                Checklist:"ALL"
            },

            departmentArr:[],
            businessRisk:[],
            componentDidMountFlag:false,
            datalist:[],
            datalistLeft:[],

            taskId:this.props.taskId,
            assignmentTypeId:this.props.assignmentTypeId,
            processId:"",
            
            templateFieldValuesMap:{},
            industrySelectAllExceptNames:[],
            // formErrors:{},
            formCustomRisk:"",
            //TAGS
            //Document
            showSelectDocumentDialog:false,
            selectedDocumentObjArr:[],
            document_NR:"",
            //Alert Info Dialog
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
            isRisk: false,
            displaySubmitForReview:false,
            displayEdit:false,
            isTemplateSettingRisk:false,
            showFrameworkClauseInfoDialog:false,
            framworkClaueItem:{},
            frameworkName:""
            // allTaskIds:this.props.allTaskIds
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.initData();
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props)){
            this.setState({
                menus:{
                    Tasks:"ALL",
                    Checklist:"ALL"
                },
    
                departmentArr:[],
                businessRisk:[],
                componentDidMountFlag:false,
                datalist:[],
                datalistLeft:[],
                formCustomRisk : "",
                taskId:this.props.taskId,
                processId:"",
                templateFieldValuesMap:{},
                // formErrors:{},
                
                //Document
                showSelectDocumentDialog:false,
                selectedDocumentObjArr:[],
                document_NR:"",
                //Alert Info Dialog
                showAlertDialogInfo:false,
                alertDialogMessageInfo:"",
                displaySubmitForReview:false,
                displayEdit:false,
                showFrameworkClauseInfoDialog:false,
                framworkClaueItem:{}
            },()=>{
                this.initData();
            });
        }
    }

    handleSubmitForReviewAndEditButton = (taskObj) => {
        let displaySubmitForReview = false;
        let displayEdit = false;

        // Check if the item is not empty and has the allowEdit property
        if(taskObj.allowEdit === "Y"){
            if(taskObj.allowReview === Constants.ALLOW_REVIEW_SUBMITREVIEW){
                displaySubmitForReview = true;
                displayEdit = true;
            }
            if(taskObj.allowReview === Constants.ALLOW_REVIEW_UPDATEREVIEWSTATUS){
                displayEdit = true;
            }
            if (taskObj.status === "Active") {
                displayEdit = true;
            }
        }
        if(taskObj.allowEdit === "N"){
            //when user has only delete permissions without edit
            if (taskObj.allowReview === Constants.ALLOW_REVIEW_SUBMITREVIEW) {
                displaySubmitForReview = true;
            }
        }
        this.setState({
            displaySubmitForReview:displaySubmitForReview,
            displayEdit:displayEdit
        })
    }

    //Document
    handleSelectDocumentDialogClose = () => {
        this.setState({
            showSelectDocumentDialog:false,
        })
    }
    handleSelectDocumentDialogShow = () => {
        this.setState({
            showSelectDocumentDialog:true,
        })
    }
    /************************API CALLS****************************/

    initData = () =>{
        this.setState({
            showLoader:true,
        })
        let postParam = {
            email:userDetails.email,
            accessToken:userDetails.accessToken,
            taskId:this.state.taskId,
            assignmentTypeId:this.props.assignmentTypeId
        }

        let postTaskDetailParam = {
            email:userDetails.email,
            accessToken:userDetails.accessToken,
            taskId:this.state.taskId
        }
        if(this.props?.isCompletedAuditee === true){
			postParam.forCompleted = true;
			postTaskDetailParam.forCompleted = true;
		}
        Promise.all([
            fetch(Constants.GetTaskCreateMasterData,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams(postParam)
            }),
            fetch(Constants.GetTaskDetails,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams(postTaskDetailParam)
            }),
        ])
        .then(([masterRes, detailsRes])=>{
            return Promise.all([masterRes.json(),detailsRes.json()]) 
        })
        .then(([masterRes, detailsRes])=>{
            let businessRisks = [];
            let deptArrTemp = [];
            let selectedDeptId = "";
            let businessRiskArr = [];
            let datalistTemp = [];
            let datalistLeftTemp = [];
            let datalist = [];
            let datalistLeft = [];
            let templateFieldValuesMap = {};
            let formCustomRisk = "";
            let isRisk = false;
            let isTemplateSettingRisk = false;
            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if(masterRes.responseCode === Constants.CODE_SUCCESS){
                let businessRiskObj = {
                    businessRiskId:-1,
                    shortName:"",
                    name:"Other",
                    description:""
                }
                businessRisks = masterRes.data.businessRisk;
                businessRisks.push(businessRiskObj);
                
                //add property "displayname: name (description)" to businessRisk array
                businessRisks.forEach(item=>{
                    if(item.name !=="Other"){
                        item.displayName = item.name+(!isEmptyVariable(item.description)?": "+item.description:"");
                    }
                    else{
                        item.displayName = item.name
                    }
                    businessRiskArr.push(item);
                    
                });

                deptArrTemp = masterRes.data.departments;
            }else{

            }

            let task = {};
            let taskObj = {};
            if(handleTokenExpiry(detailsRes.responseCode)) return;
            else if(detailsRes.responseCode === Constants.CODE_SUCCESS){
                
                taskObj = detailsRes.data.task;

                selectedDeptId = taskObj.departmentId;
                isRisk = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDRISK) && e.settingColumnEnabled === "N" && 
                        e.departmentId === selectedDeptId && e.assignmentTypeId === this.props.assignmentTypeId);
                // isTemplateSettingRisk = this.props.allSettings.some(e => e.settingColumn.includes(Constants.EXECUTION_TASK) && e.settingColumnEnabled === "Y" && 
                //         e.departmentId === selectedDeptId && e.assignmentTypeId === this.props.assignmentTypeId);
                let processId = "";
                
                let tagList = taskObj.tagList;
                let selectedDocumentObjArr = [];
                let document_NR = "";
                let selectedFunctionObjArr = [];
                let selectedAssigmentTypeObjArr = [];
                let selectedIndustryObjArr = [];
                let selectedProcessObjArr = [];
                let selectAllExceptIds = "";
                let industrySelectAllExceptNames = [];
        

                taskObj.templateFieldValues.forEach(item=>{
                    templateFieldValuesMap[JSON.stringify(item.fieldId)] = item;
                });

                if(!isEmptyVariable(taskObj.industrySelectAllExcept) &&
                    taskObj.industrySelectAllExcept === "Y" &&
                    !isEmptyVariable(taskObj.rootIndustries)){

                    //now getting top level industries directly from server
                    industrySelectAllExceptNames = taskObj.rootIndustries;
                }

                //SAMPLE REPONSE
                //"tagList":"assertion:4:Completeness3:N,assertion:1:Completeness:N,assignmentType:4:IA Assignment from L3:N,
                // assignmentType:1:Sox Assignments From L3:N,document:55:Purchase New 6:N,document:51:Purchase 2:N,
                // function:30:Import Purchase:N,function:29:Local Purchase:N,industry:34:Goods 1.2.1:N,industry:30:Goods 1.2:N,
                // process:23:Purchase Order:N",
                if(!isEmptyVariable(tagList)){
                    let tagArr = tagList.split(",");

                    tagArr.map(item => {
                        let individualTagSplitArr = item.split(":");
                        
                        if(!isEmptyVariable(individualTagSplitArr[0])){
                            switch(individualTagSplitArr[0]){
                                case "document":
                                    if(individualTagSplitArr[3] === "Y"){
                                        document_NR = "Y";
                                    }else{
                                        let obj = {
                                            documentId:individualTagSplitArr[1],
                                            name:individualTagSplitArr[2],
                                        }
                                        selectedDocumentObjArr.push(obj);
                                    }
                                    break;
                                case "function":
                                    let functionObj = {
                                        functionId:individualTagSplitArr[1],
                                        functionName:individualTagSplitArr[2],
                                    }
                                    selectedFunctionObjArr.push(functionObj);
                                    
                                    break;
                                case "industry":
                                    let industryObj = {
                                        industryId:individualTagSplitArr[1],
                                        industryName:individualTagSplitArr[2],
                                    }
                                    selectedIndustryObjArr.push(industryObj);
                                    
                                    break;
                                case "assignmentType":
                                    let assignmentTypeObj = {
                                        id:individualTagSplitArr[1],
                                        name:individualTagSplitArr[2],
                                    }
                                    selectedAssigmentTypeObjArr.push(assignmentTypeObj);
                                    
                                    break;
                                case "process":
                                    processId = individualTagSplitArr[1];
                                    let processObj = {
                                        processId:individualTagSplitArr[1],
                                        processName:individualTagSplitArr[2],
                                    }
                                    selectedProcessObjArr.push(processObj);
                                    break;
                            }
                        }
                    })
                }

                //Now Risk
                let riskObj = {
                    riskLevelId:taskObj.riskLevelId,
                    riskLevel:taskObj.riskLevel
                }

                if(!isEmptyVariable(taskObj.templateFields) && isJsonString(taskObj.templateFields)){
                    datalistTemp = JSON.parse(taskObj.templateFields);
                }
                if(!isEmptyVariable(taskObj.templateFieldsLeft) && isJsonString(taskObj.templateFieldsLeft)){
                    datalistLeftTemp = JSON.parse(taskObj.templateFieldsLeft);
                }
                // Filter out Risk/Impact field from datalist if the user does not have access to it
                if(!hasFeatureAccess(Constants.FEATURE_RISK_IMPACT)){
                    datalistTemp = datalistTemp.filter(item=>item.fieldName !== "Risk/Impact" &&
                        item.fieldType !== TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI)
                }
                //Add fieldValue and isNRChecked from ValuesMap to datalist
                datalist = datalistTemp.map(item=>{
                    if(item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                        item.fieldType === TemplateConstants.FIELD_TYPE_TABLE ){

                        if(!isEmptyVariable(templateFieldValuesMap[item.fieldId]?.value) &&
                            templateFieldValuesMap[item.fieldId]?.valueNR !== "Y" &&
                            isJsonString(templateFieldValuesMap[item.fieldId]?.value)
                        ){
                            item.fieldValue = JSON.parse(templateFieldValuesMap[item.fieldId]?.value);
                            if(item.fieldType === TemplateConstants.FIELD_TYPE_TABLE){
                                item.isTableAdded = true;
                            }
                        }else{
                            item.fieldValue = [];
                        }

                    }else{
                        if(templateFieldValuesMap[item.fieldId]?.valueNR !== "Y"){
                            item.fieldValue = templateFieldValuesMap[item.fieldId]?.value;
                        }
                    }

                    item.isNRChecked = templateFieldValuesMap[item.fieldId]?.valueNR;
                    return item;
                });

                datalistLeft = datalistLeftTemp.map(item=>{
                    if(item.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT){
                        if(!isEmptyVariable(templateFieldValuesMap[item.fieldId]?.value) &&
                            templateFieldValuesMap[item.fieldId]?.valueNR !== "Y" &&
                            isJsonString(templateFieldValuesMap[item.fieldId]?.value)
                        ){

                            item.fieldValue = JSON.parse(templateFieldValuesMap[item.fieldId]?.value);
                        }else{
                            item.fieldValue = [];
                        }
                    }else{
                        if(templateFieldValuesMap[item.fieldId]?.valueNR !== "Y"){
                            item.fieldValue = templateFieldValuesMap[item.fieldId]?.value;
                        }
                    }
                    item.isNRChecked = templateFieldValuesMap[item.fieldId]?.valueNR;
                    return item;
                });

                task = {

                    processId:processId,
                    
                    document_NR:document_NR,
                    selectedDocumentObjArr:selectedDocumentObjArr,
                    selectedIndustryObjArr:selectedIndustryObjArr,
                    selectedFunctionObjArr:selectedFunctionObjArr,
                    selectedProcessObjArr:selectedProcessObjArr,
                    selectedAssigmentTypeObjArr:selectedAssigmentTypeObjArr,
                    
                    industrySelectAll:taskObj.industrySelectAll,
                    industrySelectAllExcept:taskObj.industrySelectAllExcept,
                    industrySelectAllExceptIds:selectAllExceptIds,
                    industrySelectAllExceptNames:industrySelectAllExceptNames,
                    
                    selectedRiskObj:riskObj,
                    status:taskObj.status,
                    task:taskObj.task,
                }
                //Get Other Risk/Impact Value
                if(!isEmptyVariable(taskObj.customBusinessRisk)){
                    formCustomRisk = taskObj.customBusinessRisk;
                }
            }
            // Handle Submit for Review and Edit button
            if(this.props?.isEdit){
                this.handleSubmitForReviewAndEditButton(taskObj);
            }

            this.setState({
                showLoader:false,
                componentDidMountFlag:true,
                departmentArr:deptArrTemp,
                selectedDepartmentId:selectedDeptId,
                businessRisk:businessRiskArr,
                task:task.task,
                ...task,
                datalist: datalist,
                datalistLeft: datalistLeft,
                templateFieldValuesMap:templateFieldValuesMap,
                formCustomRisk:formCustomRisk,
                isRisk:isRisk,
                // isTemplateSettingRisk:isTemplateSettingRisk
            });
        })
    }

    getTaskTagCSV = (arr,name) => {
        let csvStr = "";
        arr.map((item,idx) =>{
            if(idx === 0){
                csvStr = item[name];
            }else{
                csvStr = csvStr+", "+item[name];
            }
        })
        return csvStr;
    }

    // handleSubmitForReview = () => {
    //     this.props.handleSubmitForReview(this.props.taskId,this.state.task)
    // }

    handleEditTask = () => {
        this.props.handleEditTask(this.props.taskId,this.props.assignmentTypeId)
    }

    nextTask = () => {
        this.props.handleShowTaskDetailsLayout(this.props.nextTaskId,this.props.assignmentTypeId)
    }

    prevTask = () => {
        this.props.handleShowTaskDetailsLayout(this.props.prevTaskId,this.props.assignmentTypeId)
    }
    
    handleAlertDialogClose = () =>{
        this.setState({
            showAlertDialog:false,
            alertDialogMessage:""
        });
    }

    frameworkClauseInfo = (item, frameworkName) => {
        this.setState({
            showFrameworkClauseInfoDialog:true,
            framworkClaueItem:item,
            frameworkName:frameworkName
        })
    }

    handleFrameworkClauseDialogClose = () => {
        this.setState({
            showFrameworkClauseInfoDialog:false,
            framworkClaueItem:{},
            frameworkName:""
        })
    }

    handleSubmitForReview = () => {
        this.setState({
            operationType:"Submit For Review",
            alertDialogHeading:"Submit For Review",
            proceedBtnLabel:"Submit",
            showAlertDialog:true,
            alertDialogMessage:"Are you sure you want to submit "+removeHtmlTags(this.state.task)+" for review?"
        })
    }

    handleRecordOperation = () => {
        this.setState({
            showBtnLoader:true,
        });

        let postParams = {
            email:userDetails.email,
            accessToken:userDetails.accessToken,
            taskId:this.state.taskId
        }
        if(this.props?.isCompletedAuditee === true){
			postParams.forCompleted = true;
		}
        fetch(Constants.SubmitTaskForReview,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams(postParams)
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    deleteReactivateId:"",
                    deleteReactivateMasterType:"",
                    operationType:"",
                    alertDialogHeading:"",
                    proceedBtnLabel:"",
                    alertDialogMessage:"",
                    showAlertDialog:false,
                    actionType:"",
                    showBtnLoader:false
                },() => {
                    this.getTaskDetails();
                    this.props.handleSubmitForReview(this.props.taskId,this.state.task)
                });
            }else{
                this.setState({
                    showLoader:false,
                });
            }
        });
    }

    getTaskDetails = () => {
        this.setState({
            showLoader:true,
        });

        let postParams = {
            email:userDetails.email,
            accessToken:userDetails.accessToken,
            taskId:this.state.taskId
        }
        if(this.props?.isCompletedAuditee === true){
			postParams.forCompleted = true;
		}
        fetch(Constants.GetTaskDetails,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams(postParams)
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let task = {};
                let taskObj = {};
                taskObj = data.data.task;
               
                task = {
                    status:taskObj.status,
                    task:taskObj.task,
                }
                this.setState({
                    showLoader:false,
                    task:task.task,
                    ...task,
                });
                // Handle Submit for Review and Edit button
                if(this.props?.isEdit){
                    this.handleSubmitForReviewAndEditButton(taskObj);
                }

            }else{
                this.setState({
                    showLoader:false,
                });
            }
        });
    }

    render(){
        return(
            <Router>
            {
                // Need to check component did mount flag, other wise until api is called,
                // it shows no items found layout.
                this.state.componentDidMountFlag &&
                <div className="m-t-10">
                    {
                        this.state.showLoader &&
                        <div class="loader"></div>
                    }
                    <div className="prev-next-layout">
                        <div className="flex-center-layout secondary-top-bar">
                            <div className="back-btn-layout" onClick={this.props.handleHideTaskDetailsLayout}>
                            <span class="material-icons-outlined">arrow_back_ios</span>
                            </div>
                            <h6>{"Task Details"}</h6>
                        </div>
                        <div className="flex-center-layout">
                            {this.props.isEdit && this.state.displayEdit &&
                                <AddNewButtonLayout themeSettings={themeSettings}>
                                    <a href="javascript:void(0);" className='edit-task' 
                                        onClick={this.handleEditTask}>
                                        <p>Edit</p>
                                    </a>
                                </AddNewButtonLayout>
                            }
                            {
                                !isEmptyVariable(this.props.prevTaskId) &&
                                <AddNewButtonLayout themeSettings={themeSettings} style={{marginLeft:10}}>
                                    <a onClick={this.prevTask} href="javascript:void(0);">
                                        <span className="material-icons">arrow_back_ios</span>
                                        <p>Prev</p>
                                    </a>
                                </AddNewButtonLayout>
                            }
                            {
                                !isEmptyVariable(this.props.nextTaskId) &&
                                <AddNewButtonLayout themeSettings={themeSettings} style={{marginLeft:10}}>
                                    <a onClick={this.nextTask} href="javascript:void(0);">
                                        <p style={{marginRight:6,marginLeft:0}}>Next</p>
                                        <span className="material-icons">arrow_forward_ios</span>
                                    </a>
                                </AddNewButtonLayout>
                            }
                        </div>
                    </div>
                    <div className="row custom-row m-t-10">
                        <div className="col-md-3 custom-col">
                            <TaskTagButtonsLayout
                            themeSettings={themeSettings}
                            >
                                <ul>
                                    {this.props.isIndustryFlag &&
                                    hasFeatureAccess(Constants.FEATURE_INDUSTRY) &&
                                    <li>
                                        <div className="tagLayout">
                                                <div className="tagHeadingLayout">
                                                    <p>Industry</p>
                                                    {
                                                        !isEmptyArray(this.state.selectedIndustryObjArr) &&
                                                        <span class="material-icons">check_circle</span>
                                                    }
                                                </div>
                                            {
                                                isEmptyArray(this.state.selectedIndustryObjArr)
                                                ?
                                                this.state.industrySelectAll === "Y"
                                                ?
                                                <p>All Industries</p>
                                                :
                                                this.state.industrySelectAllExcept === "Y"
                                                ?
                                                <p>All Industries except {this.state.industrySelectAllExceptNames}</p>
                                                :
                                                <p>{emptyString}</p>
                                                :
                                                <p>{this.getTaskTagCSV(this.state.selectedIndustryObjArr,"industryName")}</p>
                                            }
                                            
                                        </div>
                                    </li>
                                    }
                                    {hasFeatureAccess(Constants.FEATURE_DOCUMENT) &&
                                        <li>
                                            <div className="tagLayout">
                                                <div className="tagHeadingLayout">
                                                    <p>Documents</p>
                                                    {
                                                        (!isEmptyArray(this.state.selectedDocumentObjArr) ||
                                                        this.state.document_NR ==="Y") &&
                                                        <span class="material-icons">check_circle</span>
                                                    }
                                                </div>
                                                {
                                                    this.state.document_NR ==="Y"
                                                    ?
                                                    <p>{notRequiredString}</p>
                                                    :
                                                        isEmptyArray(this.state.selectedDocumentObjArr)
                                                        ?
                                                        <p>{emptyString}</p>
                                                        :
                                                        <div>
                                                            <p>{this.getTaskTagCSV(this.state.selectedDocumentObjArr,"name")}</p>
                                                            <button onClick={this.handleSelectDocumentDialogShow}>View Details</button>
                                                        </div>
                                                }
                                                
                                            </div>
                                        </li>
                                    }
                                    <li>
                                        <div className="tagLayout">
                                            <div className="tagHeadingLayout">
                                                <p>Function</p>
                                                {
                                                    !isEmptyArray(this.state.selectedFunctionObjArr) &&
                                                    <span class="material-icons">check_circle</span>
                                                }
                                            </div>
                                            {
                                                isEmptyArray(this.state.selectedFunctionObjArr)
                                                ?
                                                <p>{emptyString}</p>
                                                :
                                                <p>{this.getTaskTagCSV(this.state.selectedFunctionObjArr,"functionName")}</p>
                                            }
                                        </div>
                                    </li>
                                    {this.state.isRisk &&
                                        hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) &&
                                        hasFeatureAccess(Constants.FEATURE_TASK_TEMPLATE_MATRIX) &&
                                        <li>
                                            <div className="tagLayout">
                                                <div className="tagHeadingLayout">
                                                    <p>Risk</p>
                                                    {
                                                        !isEmptyVariable(this.state.selectedRiskObj?.riskLevelId) &&
                                                        <span class="material-icons">check_circle</span>
                                                    }
                                                </div>
                                                {
                                                    isEmptyVariable(this.state.selectedRiskObj?.riskLevelId)
                                                    ?
                                                    <p>{emptyString}</p>
                                                    :
                                                    <p>{this.state.selectedRiskObj?.riskLevel}</p>
                                                }
                                            </div>
                                        </li>
                                    }
                                    {
                                        this.state.datalistLeft.map((item,index)=>{
                                            if(item.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT){
                                                return  <li>
                                                    <div className="tagLayout">
                                                        <div className="tagHeadingLayout">
                                                            <p>{item.fieldName}</p>
                                                            {
                                                                !isEmptyVariable(item.fieldValue) &&
                                                                <span class="material-icons">check_circle</span>
                                                            }
                                                        </div>
                                                        {
                                                            isEmptyVariable(item.fieldValue)
                                                            ?
                                                            <p>{emptyString}</p>
                                                            :
                                                            <p>{item.fieldValue}</p>
                                                        }
                                                    </div>
                                                </li>

                                            }else if(item.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT){
                                                return  <li>
                                                    <div className="tagLayout">
                                                        <div className="tagHeadingLayout">
                                                            <p>{item.fieldName}</p>
                                                            {
                                                                !isEmptyArray(item.fieldValue) &&
                                                                <span class="material-icons">check_circle</span>
                                                            }
                                                            
                                                        </div>
                                                        {
                                                            isEmptyArray(item.fieldValue)
                                                            ?
                                                            <p>{emptyString}</p>
                                                            :
                                                            <p>{item.fieldValue.join(", ")}</p>
                                                        }
                                                    </div>
                                                </li>

                                            }else if(item.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE){
                                                return  <li>
                                                    <div className="tagLayout">
                                                        <div className="tagHeadingLayout">
                                                            <p>{item.fieldName}</p>
                                                            {
                                                                !isEmptyVariable(item.fieldValue) &&
                                                                <span class="material-icons">check_circle</span>
                                                            }
                                                            
                                                        </div>
                                                        {
                                                            isEmptyVariable(item.fieldValue)
                                                            ?
                                                            <p>{emptyString}</p>
                                                            :
                                                            <p>{item.fieldValue}</p>
                                                        }
                                                    </div>
                                                </li>

                                            }else if(item.fieldType === TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE){
                                                return  <li>
                                                    <div className="tagLayout">
                                                        <div className="tagHeadingLayout">
                                                            <p>{item.fieldName}</p>
                                                            {
                                                                !isEmptyVariable(item.fieldValue) &&
                                                                <span class="material-icons">check_circle</span>
                                                            }
                                                            
                                                        </div>
                                                        {
                                                            isEmptyVariable(item.fieldValue)
                                                            ?
                                                            <p>{emptyString}</p>
                                                            :
                                                            <p>{item.fieldValue}</p>
                                                        }
                                                    </div>
                                                </li>
                                            }
                                        })
                                    }

                                    {/* {
                                        this.state.datalistLeft.map((item,index)=>{
                                            return (
                                                <li>
                                                    {
                                                        item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN &&
                                                        <div className="tagLayout">
                                                            <div className="tagHeadingLayout">
                                                                <p>{item.fieldName}{item.isMandatorySelected === "Y"?"*":""}</p>
                                                                {
                                                                    !isEmptyVariable(item.fieldValue) &&
                                                                    <span class="material-icons">check_circle</span>
                                                                }
                                                            </div>
                                                            {
                                                                isEmptyVariable(item.fieldValue)
                                                                ?
                                                                <p>{emptyString}</p>
                                                                :
                                                                <p>{item.fieldValue}</p>
                                                            }
                                                        </div>
                                                    }
                                                    {
                                                        item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
                                                        <div className="tagLayout">
                                                            <div className="tagHeadingLayout">
                                                                <p>{item.fieldName}{item.isMandatorySelected === "Y"?"*":""}</p>
                                                                {
                                                                    !isEmptyArray(item.fieldValue) &&
                                                                    <span class="material-icons">check_circle</span>
                                                                }
                                                            </div>
                                                            {
                                                                isEmptyArray(item.fieldValue)
                                                                ?
                                                                <p>{emptyString}</p>
                                                                :
                                                                <p>{item.fieldValue.join(", ")}</p>
                                                            }
                                                        </div>
                                                    }
                                                </li>
                                            )
                                        })
                                    } */}
                                </ul>
                            </TaskTagButtonsLayout>
                        </div>
                        <div className="col-md-9 custom-col">
                            <div className='editor-card'>
                                <h6>{this.getTaskTagCSV(this.state.selectedProcessObjArr,"processName")}</h6>
                            </div>
                            {
                                this.state.datalist.map((item,index)=>{
                                    let showHeader = true;
                                    if(TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI){
                                        if(item.isFromRiskMaster){
                                            if(item.isRiskMasterEnabled === "Y"){
                                                showHeader = true;
                                            }else{
                                                showHeader = false;
                                            }
                                        }else{
                                            showHeader = true;
                                        }
                                    }
                                    return (
                                    <div class="editor-card">
                                        {
                                            showHeader &&
                                            <div className={item.isNotReqSelected === "Y"?"task-header-layout editor-border-bottom m-b-0":"task-header-layout editor-border-bottom"}>
                                                <h6 className="editor-heading">
                                                {item.fieldName}{item.isMandatorySelected === "Y"?"*":""}
                                                </h6>
                                                {
                                                    item.isNotReqSelected === "Y"
                                                    ?
                                                        <FilterCheckBox themeSettings={themeSettings}
                                                        style={{marginLeft:0}}>
                                                            <input 
                                                                type="checkbox"
                                                                name={item.fieldName+":-:"+index}
                                                                id={item.fieldName+":-:"+index}
                                                                onChange={this.handleCheck}
                                                                disabled={true}
                                                                checked={item.isNRChecked === "Y"?true:false}
                                                            />
                                                            <label for={item.fieldName+":-:"+index}>Not Required</label>
                                                        </FilterCheckBox>
                                                    :
                                                        <div />
                                                }
                                            </div>
                                        }

                                        {
                                            item.fieldType === TemplateConstants.FIELD_TYPE_TEXT &&
                                            <div class="row custom-row">
                                                <div class="col-md-12 custom-col">
                                                    {
                                                        item.isNRChecked !== "Y" &&
                                                        <div class="editor-text-layout">
                                                            {
                                                                isEmptyVariable((item.fieldValue))
                                                                ?
                                                                <p>{emptyString}</p>
                                                                :
                                                                    (isEmptyVariable(removeHtmlTags(item.fieldValue))
                                                                    ?<p>{emptyString}</p>
                                                                    :
                                                                    <div dangerouslySetInnerHTML={{__html: item.fieldValue}} />)
                                                            }
                                                            
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {
                                            item.fieldType === TemplateConstants.FIELD_TYPE_DATE &&
                                            <div class="row custom-row">
                                                <div class="col-md-12 custom-col">
                                                    {
                                                        item.isNRChecked !== "Y" &&
                                                        <div class="editor-text-layout">
                                                            {
                                                                isEmptyVariable((item.fieldValue))
                                                                ?
                                                                <p>{emptyString}</p>
                                                                :
                                                                <p>{moment(item.fieldValue).format("DD/MM/YYYY")}</p>
                                                            }
                                                            
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {
                                            item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
                                            item.isRiskMasterEnabled === "Y" &&
                                            item.isFromRiskMaster &&
                                            <div class="row custom-row">
                                                <div class="col-md-12 custom-col">
                                                    <div class={item.isNRChecked === "Y"?"editor-disabled":""}>
                                                    {
                                                        isEmptyArray(item.fieldValue)?
                                                        <p className="m-b-0">-</p>
                                                        :
                                                        (
                                                        <ul style={{marginBottom:5,paddingLeft:25}}>
                                                            {
                                                                this.state.businessRisk.map(riskItem=>{
                                                                    if(item.fieldValue.includes(riskItem.businessRiskId)){

                                                                        return(
                                                                            <li className="m-b-0 font-size-p">{riskItem.displayName}</li>
                                                                        )
                                                                    }
                                                                })  
                                                            }
                                                        </ul>)
                                                    }
                                                    {
                                                        item.fieldValue.some(fieldItem => fieldItem === -1)  &&
                                                        <div class="editor-text-layout">
                                                            <div style={{marginLeft:25}}
                                                            dangerouslySetInnerHTML={{__html: this.state.formCustomRisk}} />
                                                        </div>
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {
                                            item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
                                            !item.isFromRiskMaster &&
                                            <div class="row custom-row">
                                                <div class="col-md-12 custom-col">
                                                    <div class={item.isNRChecked === "Y"?"editor-disabled":""}>
                                                    {
                                                        isEmptyArray(item.fieldValue)?
                                                        <p className="m-b-0">-</p>
                                                        :
                                                        (
                                                        <ul style={{marginBottom:5,paddingLeft:25}}>
                                                            {
                                                                item.fieldValue.map(valueItem=>{

                                                                    return(
                                                                        <li className="m-b-0 font-size-p">{valueItem}</li>
                                                                    )
                                                                })  
                                                            }
                                                        </ul>)
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        
                                        {
                                            item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN &&
                                            <div class="row custom-row">
                                                <div class="col-md-12 custom-col">
                                                    <div class={item.isNRChecked === "Y"?"editor-disabled":""}>
                                                    {
                                                        isEmptyVariable(item.fieldValue)?
                                                        <p className="m-b-0">-</p>
                                                        :
                                                        <p>{item.fieldValue}</p>
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {
                                            item.fieldType === TemplateConstants.FIELD_TYPE_TABLE &&
                                            item.isUsedForExec !== "Y" &&
                                            <div className="flex-center-layout" style={{justifyContent:"center"}}>
                                                {
                                                    !item.isTableAdded &&
                                                    <p>{emptyString}</p> 
                                                }
                                                {
                                                    item.isTableAdded &&
                                                    <div
                                                        style={{ width: "100%", marginTop: 10, boxShadow: "none" }}
                                                        class={
                                                            item.isNRChecked === "Y"
                                                                ? "editor-layout editor-disabled common-table"
                                                                : "common-table editor-layout"
                                                        }
                                                    >
                                                
                                                        <table class="table instances-table">
                                                            
                                                            {
                                                                item.fieldValue.map((rowItem, rowIndex) =>  {
                                                                    if(rowIndex === 0){
                                                                        return <thead className="instances-thead">
                                                                            <tr>
                                                                            {
                                                                                rowItem.map((colItem, colIndex) => {
                                                                                    if(colIndex !== rowItem.length-1){

                                                                                        return <th className="text-center">
                                                                                            <div className="instances-table-header">
                                                                                                <p>
                                                                                                    {colItem}
                                                                                                </p>
                                                                                            </div>
                                                                                        </th>
                                                                                    }
                                                                                })
                                                                            }
                                                                            </tr>
                                                                            </thead>
                                                                            
                                                                    }else{
                                                                        return <tbody className="instances-thead">
                                                                            <tr>
                                                                            {
                                                                                rowItem.map((colItem, colIndex) => {
                                                                                    if(colIndex !== rowItem.length-1){

                                                                                        return <td className="text-center">
                                                                                            {colItem}
                                                                                        </td>
                                                                                    }
                                                                                })
                                                                            }
                                                                            </tr>
                                                                        </tbody>

                                                                    }

                                                                })
                                                            }
                                                        </table>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {
                                            item.fieldType === TemplateConstants.FIELD_TYPE_TABLE &&
                                            item.isUsedForExec === "Y" &&
                                            <div className="flex-center-layout" style={{justifyContent:"center"}}>
                                                {
                                                    !item.isTableAdded &&
                                                    <p>{emptyString}</p> 
                                                }
                                                {
                                                    item.isTableAdded &&
                                                    <div
                                                        style={{ width: "100%", marginTop: 10, boxShadow: "none" }}
                                                        class={
                                                            item.isNRChecked === "Y"
                                                                ? "editor-layout editor-disabled common-table"
                                                                : "common-table editor-layout"
                                                        }
                                                    >
                                                
                                                        <table class="table instances-table">
                                                            
                                                            {
                                                                !isEmptyVariable(item?.fieldValue?.tableArray) &&
                                                                item.fieldValue.tableArray.map((rowItem, rowIndex) =>  {
                                                                    if(rowIndex === 0){
                                                                        return <thead className="instances-thead">
                                                                            <tr>
                                                                            {
                                                                                rowItem.map((colItem, colIndex) => {
                                                                                    if(colIndex !== rowItem.length-1){

                                                                                        return <th className="text-center">
                                                                                            <div className="instances-table-header">
                                                                                                <p>
                                                                                                    {colItem}
                                                                                                </p>
                                                                                            </div>
                                                                                        </th>
                                                                                    }
                                                                                })
                                                                            }
                                                                            </tr>
                                                                            </thead>
                                                                            
                                                                    }else{
                                                                        return <tbody className="instances-thead">
                                                                            <tr>
                                                                            {
                                                                                rowItem.map((colItem, colIndex) => {
                                                                                    if(colIndex !== rowItem.length-1){

                                                                                        return <td className="text-center">
                                                                                            {colItem}
                                                                                        </td>
                                                                                    }
                                                                                })
                                                                            }
                                                                            </tr>
                                                                        </tbody>

                                                                    }

                                                                })
                                                            }
                                                        </table>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {item.fieldType === TemplateConstants.FIELD_TYPE_FRAMEWORK &&
                                            <div className="row custom-row">
                                                <div className="col-md-12 custom-col">
                                                    <div className={item.isNRChecked === "Y"?"editor-disabled":""}>
                                                    {
                                                        isEmptyArray(item.fieldValue) ?
                                                        <p className="m-b-0">-</p>
                                                        :
                                                        (
                                                            item.frameworkList.map((framework) => {
                                                                // Filter clauses belonging to this framework
                                                                const clauses = item.fieldValue.filter(frameworkItem => frameworkItem.frameworkId + "" === framework.frameworkId + "");
                                                                console.log(clauses,"::clayse")
                                                                // Determine if only one framework is used (to decide whether to show the name)
                                                                const uniqueFrameworkIds = [...new Set(item.fieldValue.map(val => val.frameworkId))];
                                                                const singleFrameworkUsed = uniqueFrameworkIds.length === 1;

                                                                if (clauses.length === 0) return null;

                                                                // 1. Map clauses to a JSX component array (Clause + Icon)
                                                                const clause = clauses.map((clause, index) => {
                                                                    // Ensure the clause name is displayed properly (with HTML applied)
                                                                    const clauseNameHtml = clause.frameworkClauseName; 

                                                                    // Determine if we need a comma/space separator before the next item
                                                                    const isLastClause = index === clauses.length - 1;
                                                                    const separator = isLastClause ? "" : ",\u00A0"; // Non-breaking space

                                                                    return (
                                                                        <span key={clause.frameworkClauseId || index} 
                                                                        className={`framework-clause-item d-inline-flex align-items-center ${singleFrameworkUsed ? 'framework-hover-trigger' : ''}`}>
                                                                        
                                                                        {/* 1a. Clause Name (HTML rendered) - This is the trigger area */}
                                                                        <span 
                                                                            dangerouslySetInnerHTML={{ __html: clauseNameHtml }} 
                                                                            className={`framework-item`}
                                                                        />
                                                                        
                                                                        {/* 1b. Info Icon for the specific clause - This is the hidden item */}
                                                                        <span className="tool clause-info-icon hover-item" data-title="Clause Details">
                                                                            <TableIcon themeSettings={themeSettings} className="text-center" style={{ marginLeft: 8 }}>
                                                                                <span
                                                                                    onClick={this.frameworkClauseInfo.bind(this, clause, framework.frameworkName)} 
                                                                                    className="material-icons-outlined framework-icon"
                                                                                    style={{ cursor: 'pointer',verticalAlign: 'middle',fontSize: '18px' }}
                                                                                >
                                                                                    info
                                                                                </span>
                                                                            </TableIcon>
                                                                        </span>
                                                                        <span className="framework-item">{separator}</span>
                                                                    </span>
                                                                    );
                                                                });

                                                                return (
                                                                    <div key={framework.frameworkId} className={`d-flex flex-wrap align-items-center ${!singleFrameworkUsed ? 'framework-group-line' : ''}`}>                                                                            
                                                                        {/* Display Framework Name if multiple frameworks are present */}
                                                                        {!singleFrameworkUsed && (
                                                                            <p className="framework-item">{framework.frameworkName} -{'\u00A0'}</p>
                                                                        )}
                                                                        {/* Render the Array of Clause components directly */}
                                                                        <span className="framework-item clause-list-container">{clause}</span>
                                                                    </div>
                                                                );
                                                            })
                                                        )
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    )
                                })
                            }
                            
                        </div>
                    
                    </div>
                    {this.state.displaySubmitForReview &&
                        <div className="row custom-row">
                            <div className="col-md-12 custom-col">
                                <div className="common-close-save m-b-20">
                                    <div className="common-close-save-col">
                                        <PageSaveButton
                                            themeSettings={themeSettings}
                                            onClick={()=>{this.handleSubmitForReview()}}
                                            type="button"
                                        >
                                            Submit For Review
                                        </PageSaveButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <SelectedDocumentDialog
                        showDocumentDialog={this.state.showSelectDocumentDialog}
                        handleSelectDocDialogClose={this.handleSelectDocumentDialogClose}
                        taskId={this.state.taskId}
                        subscriptionType={this.props.subscriptionType}
                        themeSettings = {themeSettings}
                    />
                </div>
            }
            <AlertDialog
                showAlertDialog={this.state.showAlertDialog}
                handleAlertDialogClose={this.handleAlertDialogClose}
                type={Constants.ALERT_TYPE_INFO}
                alertDialogHeading={this.state.alertDialogHeading}
                alertDialogMessage={this.state.alertDialogMessage}
                proceedBtnClick={this.handleRecordOperation}
                proceedBtnLabel={this.state.proceedBtnLabel}
                showLoader={this.state.showBtnLoader}
                themeSettings={themeSettings}
            />
            <FrameworkClauseInfoDialog
                showFrameworkClauseInfoDialog={this.state.showFrameworkClauseInfoDialog}
                handleFrameworkClauseDialogClose={this.handleFrameworkClauseDialogClose}
                framworkClaueItem={this.state.framworkClaueItem}
                frameworkName={this.state.frameworkName}
            />
            </Router>
        )
    }
}

export default TaskDetails;